import { createFileRoute, Outlet } from '@tanstack/react-router';

import VStack from '@/components/Layout/VStack';

import GroupIdBreadcrumb from './_$id/-components/Header/GroupIdBreadcrumb';
import GroupIdHeader from './_$id/-components/Header/GroupIdHeader';
import GroupIdHeaderTabs from './_$id/-components/Header/GroupIdHeaderTabs';

export const Route = createFileRoute('/_staff/ids/group-id/$id/_$id')({
  component: Layout,
});

function Layout() {
  return (
    <VStack>
      <VStack className="gap-4 bg-background px-12 pt-4 shadow-xs">
        <GroupIdBreadcrumb />
        <GroupIdHeader />
        <GroupIdHeaderTabs />
      </VStack>
      <Outlet />
    </VStack>
  );
}
